import React from "react";
import Container from "../components/wrapper/container.wrapper";
import * as User from "../modules/user";
import {UserModuleStoreInterface} from "../types";
import {RouteObject} from "react-router-dom";
import ErrorBoundary from "../components/wrapper/errorBoundary.wrapper";

export const UserRouter = ({ isAuthenticated, userStore }: {
    isAuthenticated: () => boolean,
    userStore:  UserModuleStoreInterface
}): RouteObject => (
    {
        path: "/",
        element: <Container/>,
        children: [
            {
                path: "/user",
                element: <User.List />,
                errorElement: <ErrorBoundary hasError={true} />,
            },
            {
                path: "/user/:id/edit",
                element: <User.Edit />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return userStore.prepareEditForm({ id: params.id });
                },
            },
            {
                path: "/user/add",
                element: <User.Add />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return userStore.prepareAddForm();
                },
            },
            {
                path: "/user/:id/view",
                element: <User.View />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async ({params}: any) => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return userStore.view({ id: params.id });
                },
            },
            {
                path: "/user/:id/password/edit",
                element: <User.PasswordEdit />,
                errorElement: <ErrorBoundary hasError={true} />,
            },
            {
                path: "/my_account",
                element: <User.MyAccount />,
                loader: async () => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return userStore.myAccount();
                },
            },
            {
                path: "/my_account/edit",
                element: <User.MyAccountEdit />,
                errorElement: <ErrorBoundary hasError={true} />,
                loader: async () => {
                    if (!isAuthenticated()) {
                        return new Promise((reject) => {
                            reject(null)
                        })
                    }

                    return userStore.myAccount();
                },
            },
            {
                path: "/my_account/password/edit",
                errorElement: <ErrorBoundary hasError={true} />,
                element: <User.MyAccountPasswordEdit />,
            }
        ]
    }
)